export default "__VITE_ASSET__D5T6iZI6__"